/** Optional native projection. Caller metadata and matching prose are never
 * evidence that a stored template body was generated by the product. */
export interface TemplatePresentation {
  version: 1;
  template_name: string;
  source_content: string;
}
export interface TemplatePresentationSource {
  direction?: string;
  message_type?: string;
  content?: string | null;
  template_presentation?: unknown;
}

export function readTemplatePresentation(message: TemplatePresentationSource): TemplatePresentation | undefined {
  const value = message.template_presentation;
  if (message.direction !== 'outbound' || message.message_type !== 'template' ||
      !value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  const p = value as Record<string, unknown>;
  if (p.version !== 1 || typeof p.template_name !== 'string' || !p.template_name.trim() ||
      p.source_content !== message.content || message.content !== '[Plantilla: ' + p.template_name + ']') return undefined;
  return { version: 1, template_name: p.template_name, source_content: message.content };
}

/** Quotes/composer presentation only; the source message and send body survive
 * a language change byte-for-byte. */
export function generatedTemplateText(message: TemplatePresentationSource, t: (key: string) => string): string | undefined {
  const p = readTemplatePresentation(message);
  return p ? '[' + t('interactive.templateLabel') + ': ' + p.template_name + ']' : undefined;
}
